'use client';

import { useState } from 'react';

import Logo from '@/entites/logo/ui/Logo';
import PcLanguageSwitcher from '@/features/language-switcher/ui/PcLanguageSwitcher';
import { useSubmenuHeight } from '@/features/navigation/hooks/useSubmenuHeight';
import PcNavigation from '@/features/navigation/ui/PcNavigation';

const PcHeader = () => {
  const { height, submenuRef, updateHeight, resetHeight } = useSubmenuHeight();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      <header
        style={{
          height: `${height}px`,
          transitionDuration: height > 0 ? '500ms' : '0ms', // 높이가 증가할 때만 애니메이션
        }}
        onMouseLeave={() => {
          resetHeight();
          setIsHovered(false);
        }}
        className="bg-white absolute left-0 right-0 top-0 z-20 w-full transition-[height] ease-in-out"
      >
        <div className={'max-w-[1900px] mx-auto'}>
          <div className={`px-[64px] flex items-center gap-[clamp(40px,calc(12.5vw-100px),120px)]`}>
            <Logo theme={'default'} />
            <PcNavigation
              submenuRef={submenuRef}
              onSubmenuEnter={updateHeight}
              height={height}
              isHovered={isHovered}
              setIsHovered={setIsHovered}
            />
            <div className="ml-auto">
              <PcLanguageSwitcher />
            </div>
            {height > 0 && <div className="border-b-2 absolute top-[100px] w-full left-0" />}
          </div>
        </div>
      </header>
      <div
        style={{
          transitionDuration: height > 0 ? '500ms' : '0ms', // 딤처리가 생길 때만 애니메이션
        }}
        className={`fixed left-0 right-0 w-full h-full transition-opacity ease-in-out ${
          height > 0 ? 'opacity-40 bg-[#000000] z-10' : 'opacity-0 pointer-events-none'
        }`}
      ></div>
    </>
  );
};

export default PcHeader;
